__turbopack_context__.v({
  "fullWidth": "Relics-module___JRbZq__fullWidth",
  "label": "Relics-module___JRbZq__label",
  "negative": "Relics-module___JRbZq__negative",
  "root": "Relics-module___JRbZq__root",
});
